import { DecimalPipe, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PositionBase } from '@zero/instrument-details/feature-instrument-details/base';
import { PriceScalePipe } from '@zero/shared/ui-pipes';
import { ModalComponent, PillComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'instrument-details-instrument-position',
  templateUrl: './position-web.component.html',
  imports: [DecimalPipe, PriceScalePipe, TranslocoPipe, RouterLink, NgTemplateOutlet, PillComponent, UpperCasePipe, ModalComponent],
})
export class PositionWebComponent extends PositionBase {
  public readonly modal = inject(NgbModal);
  public readonly instrumentDetailsPage = commonRoutes.postlogin.instrument_detail;
}
